import { render, staticRenderFns } from "./WorldViewList.vue?vue&type=template&id=184166c5&scoped=true"
import script from "./WorldViewList.vue?vue&type=script&lang=ts"
export * from "./WorldViewList.vue?vue&type=script&lang=ts"
import style0 from "./WorldViewList.vue?vue&type=style&index=0&id=184166c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184166c5",
  null
  
)

export default component.exports